// The pack's title key as the shop shows it (see StorePack's getPromoPackDetails and
// SystemMessage's resolvePackName): north/south titles by the player's side, else the special title.
function packTitleKey(pack, side) {
    if (pack.titleNorthKey && pack.titleSouthKey) {
        return side === 1 ? pack.titleNorthKey : pack.titleSouthKey;
    }
    return pack.specialTitle;
}

// The description init-payment sends PaymentHub, which shows it at checkout and refuses a basket
// whose description is "". The game's Save More drawer puts the pack's title in the link; its
// mail deep link to a webshop-exclusive pack does not, so the pack names itself. `translate`
// answers '' for a key the dictionary does not have.
export function basketDescription({ packTitle, pack, side, translate, fallback }) {
    if (packTitle?.trim()) return packTitle;
    const key = packTitleKey(pack, side);
    const name = key ? translate(key) : '';
    return name?.trim() ? name : fallback;
}
